import Highcharts from 'highcharts';

const chartHeights = {
  dashboard: '40%',
  results: '47%',
  filters: '47%',
  'job-question': '60%'
};

export const getCharHeightForChartTypeAndWidth = (type, width) => {
  if (width <= 768) {
    return '90%';
  }
  return chartHeights[type] || '47%';
};

export const getMaxValueFromResults = (results) => {
  return results.reduce((acc, res) => (acc += res.value_count), 0);
};

export const getPercentageFormatter = function (results, key = 'value') {
  const dataSum = getMaxValueFromResults(results);
  return function () {
    const val = (this[key] / dataSum) * 100;
    return `${Highcharts.numberFormat(val, 0)}%`;
  };
};

export const getPercentageFormatterForBar = function (results, key = 'value') {
  return function () {
    const val = (this[key] / results) * 100;
    return `${Highcharts.numberFormat(val, 0)}%`;
  };
};

export const getChartLegend = function (variable) {
  let legend = '';
  if ((variable.min || variable.min === 0) && variable.min_label) {
    legend += `${variable.min} = ${variable.min_label}`;
  }
  if (variable.max && variable.max_label) {
    legend +=
      (legend.length ? ', ' : '') + `${variable.max} = ${variable.max_label}`;
  }
  return legend;
};
